import RestrictOpeningTimesBlock from './RestrictOpeningTimesBlock';

export default RestrictOpeningTimesBlock;
